export { default } from './SpeedDialAction';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/lab/esm/SpeedDialAction/index.js
// module id = 377
// module chunks = 0